import { useEffect, useState } from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import { useGetSchoolsQuery } from "state/api";
import Header from "components/Header";
import { useSelector } from "react-redux";
import { RootState } from "state";
import { iAdminDashboardData } from "types/AdminDashboardData";
import AdminDashboardSummary from "components/AdminDashboardSummary";
import SchoolGrid from "components/SchoolGrid";

const AdminDashboard = () => {
  const [skip, setSkip] = useState(true);
  // const { user } = useSelector((state: RootState) => state.auth);
  const [dashboardData, setDashboardData] = useState<iAdminDashboardData>({
    numberOfSchools: 0,
    numberOfStudents: 0,
    testsTaken: 0,
    overallPerformance: 0,
  });

  const { data: schoolsData, isLoading: isSchoolsDataLoading } =
    useGetSchoolsQuery();

  useEffect(() => {
    if (schoolsData) {
      var dashboardData: iAdminDashboardData = {
        numberOfSchools: 0,
        numberOfStudents: 0,
        testsTaken: 0,
        overallPerformance: 0,
      };
      var numOfSchoolsWithData = 0;
      dashboardData.numberOfSchools = schoolsData.length;
      for (const school of schoolsData) {
        if (
          school?.aggregateData &&
          Object.keys(school.aggregateData).length > 0
        ) {
          numOfSchoolsWithData++;
          dashboardData.numberOfStudents +=
            school.aggregateData.schoolStrength || 0;
          dashboardData.testsTaken += school.aggregateData.testTaken || 0;
          dashboardData.overallPerformance +=
            school.aggregateData.overallPerformance || 0;
        }
      }
      dashboardData.overallPerformance =
        dashboardData.overallPerformance / numOfSchoolsWithData;
      console.log(dashboardData);
      setDashboardData(dashboardData);
    }
  }, [schoolsData]);

  const isNonMobile = useMediaQuery("(min-width: 600px)");
  const theme = useTheme();

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="Admin Dashboard" subtitle={""} />
      {schoolsData || !isSchoolsDataLoading ? (
        <Box sx={{ flexGrow: 1, padding: 2 }}>
          <AdminDashboardSummary {...dashboardData} />
        </Box>
      ) : (
        <>Loading...</>
      )}
      <SchoolGrid
        data={schoolsData}
        isLoading={isSchoolsDataLoading}
        displayHeader={true}
      />
    </Box>
    // <div>
    //   <Profile />
    // </div>
  );
};

export default AdminDashboard;
